module.exports = __webpack_public_path__ + "img/active-user.d93bbf7b.png";